var render = function render(){var _vm=this,_c=_vm._self._c;return _c('line',{style:([
    _vm.isActive
      ? { stroke: 'rgb(255, 255, 255)', 'stroke-width': '2' }
      : { stroke: 'rgb(255, 153, 0)', 'stroke-width': '2' }
  ]),attrs:{"x1":_vm.startCoordinates.x,"y1":_vm.startCoordinates.y,"x2":_vm.endCoordinates.x,"y2":_vm.endCoordinates.y,"stroke-dasharray":4}})
}
var staticRenderFns = []

export { render, staticRenderFns }